import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.swiper-container').forEach((container) => {
        const swiperOptions = JSON.parse(container.getAttribute('data-swiper-options'));

        const swiper = new Swiper(container, {
            ...swiperOptions,
            modules: [Navigation, Pagination, Autoplay],
        });
    });
});